import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import ImageGrid from './ImageGrid';
import LoadingCard from 'components/loading/LoadingCard';
import { connect } from 'react-redux';

class ImageContainer extends React.Component {
    componentDidMount() {
        const { fetch, id } = this.props;

        fetch({ id });
    }

    componentDidUpdate(prevProps) {
        const {
            fetch,
            id,
        } = this.props;

        if (id !== prevProps.id) {
            fetch({ id });
        }
    }

    render() {
        const {
            createAction,
            data,
            id,
            loading,
            onDelete,
            onHighlightImage,
            showHighlightOption,
        } = this.props;

        if (loading || !data) {
            return <LoadingCard />;
        }

        return <ImageGrid
            createAction={ createAction }
            data={ data }
            id={ id }
            onDelete={ onDelete }
            onHighlightImage={ onHighlightImage }
            showHighlightOption={ showHighlightOption }
        />;
    }

}

ImageContainer.propTypes = {
    createAction: PropTypes.func.isRequired,
    data: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onDelete: PropTypes.func.isRequired,
    onHighlightImage: PropTypes.func,
    showHighlightOption: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const {
        id,
        source,
    } = props;

    return {
        data: state[source].data[id],
        id: id,
        loading: state[source].loading,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        action,
        deleteAction,
        highlightImageAction,
    } = props;

    return {
        fetch: (payload) => {
            dispatch(action(payload));
        },
        onDelete: (payload) => {
            dispatch(deleteAction(payload));
        },
        onHighlightImage: (payload) => {
            dispatch(highlightImageAction(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(ImageContainer);



// WEBPACK FOOTER //
// ./src/pages/products/images/ImageContainer.js